import React, { useState, useContext, useEffect, useRef } from "react";
import "./navbar.css"
import "./banner.css"
import "../../components/filter/filter.css"
import logo from "../../assets/logoTextDark.png"
import { Context } from "../../app";
import { useNavigate } from "react-router-dom";
import { Mixpanel } from "../../Mixpanel";
import { useSearchParams } from "react-router-dom";

function Navbar(props) {
    
    const [expandProducts, setExpandProducts] = useState(false)
    const [expandMenu, setExpandMenu] = useState(false)
    const total = useRef()

    const shop = useContext(Context)
    const [searchParams, setSearchParams] = useSearchParams()
    let navigate = useNavigate()

    useEffect(()=>{

    },[])

    function productsClicked() {
        console.log("yo")
        setExpandProducts(!expandProducts)
        setExpandMenu(false)
    }

    function menuClicked() {
        setExpandProducts(false)
        setExpandMenu(!expandMenu)
    }

    useEffect(()=>{

    }, [shop.cart])



    return(
        // <div className="navbar-component">
        <>
            <div className="banner">
                <p>Get up to 25% discount Off all items</p>
            </div>
            <div className="navbar">
                <a href="https://www.myvigilapp.com" className="navLogo">
                    <img id="navLogo" src="logoTextDark.png" width="100%" alt="" />
                </a>
                <div className="navLinks">
                    <a className="navLink" href="https://www.myvigilapp.com">Home</a>
                    <button onClick={()=>navigate("/")} className="navLink btn--flat">Back</button>
                    <button onClick={()=>shop.setShowCart(!shop.showcart)} id="checkout-link" className="navLink btn--flat">
                        <i className="material-icons-outlined">shopping_bag</i>
                        <p className="cart-total">{shop.cart.reduce((a,b)=>a+b.quantity, 0)}</p>
                    </button>
                    
                </div>
            </div>

        {/* </div> */}
        </>
    )
}

export default Navbar